export const getLocale = (): string =>
  window.navigator.language ??
  new Intl.DateTimeFormat().resolvedOptions().locale;
